import { useNavigate, useParams } from 'react-router-dom';
import { useCerebroNav } from '../context';
import { useNavigationBlockerContext } from '../context/NavigationBlockerContext';

export function useNavigateToNextPage() {
	const { state } = useNavigationBlockerContext();
	const navigate = useNavigate();
	const { nextNavItem } = useCerebroNav();
	const { guid } = useParams<'guid'>();

	const canNavigate = state === 'Idle';

	return () => {
		if (nextNavItem !== undefined && canNavigate) {
			navigate(`/${guid}/${nextNavItem.url}`);
		}
	};
}
